module.exports = __webpack_public_path__ + "static/img/title.4a9dd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/title.png
// module id = +ygy
// module chunks = 0